import { API_BASE_URL } from "./api-base";

// 后台驱动的语言列表接口（$noNeedLogin，不带 token 直接请求）。

const LANGUAGES_URL = `${API_BASE_URL}/api/index/languages`;

// 兼容 code 为 0 / 1 / 200 的成功约定，只要 data 是数组就认
function readList(json) {
  if (!json || typeof json !== "object") return null;
  const data = json.data;
  if (Array.isArray(data)) return data;
  if (data && Array.isArray(data.list)) return data.list;
  if (Array.isArray(json.list)) return json.list;
  return null;
}

async function getList(url) {
  const resp = await fetch(url, {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  });
  if (!resp.ok) throw new Error(`HTTP ${resp.status}`);

  const json = await resp.json();
  const list = readList(json);
  if (!list) {
    throw new Error((json && (json.msg || json.message)) || "Request failed");
  }
  return list;
}

// GET /api/index/languages —— 后台「语言管理」中启用的语言，weigh desc / id asc
// 返回 [{ code, name, english_name, flag }]
export function getLanguages() {
  return getList(LANGUAGES_URL);
}
